<app-custom-table
  titleSingleResult="Buchung"
  titleMultipleResults="Buchungen"
  class="w-full"
  noDataIcon="fa-book-open-cover"
  noDataMessage="Du hast derzeit keine Buchungen verfügbar."
  noSearchResultsIcon="fa-book-open-cover"
  noSearchResultsMessage="Es gibt keine Buchungen, die mit deinen Suchkriterien übereinstimmen."
  [columns]="columns"
  [dataSource$]="dataSource$"
  [isLoading]="isLoading"
  [filters]="filters" />
